import {createApp} from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router/index.js'

createApp(App).use(router, axios).mount('#app')
